import React, { useState, useRef, useEffect } from "react";

import logo from '../../icons/photos/chillLogo.png'
import PrimaryButton from "../../jsx/components/button/primaryButton";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import FeedbackModal from "../../jsx/components/feedback/feedback";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";

const ScheduleCallDownload = () => {
    const { authorized } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const [downloadId, setDownloadId] = useState();
    // const [pageType, setPageType] = useState('');
    const [feedbackMessage, setFeedbackMessage] = useState("")
    const [feedbackModal, setFeedbackModal] = useState(false);
    const [handleToaster, setHandleToaster] = useState(false);

    let pageType = "";
    if (urlParams.has('serviceRequestId')) {
        const ticketIdDownlaod = urlParams.get('serviceRequestId')
        localStorage.setItem("ticketIdDownlaod", ticketIdDownlaod)
    }

    if (urlParams.has('page')) {
        pageType = urlParams.get('page')
        // setPageType(page)
    }

    const downloadFile = () => {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const url = `${process.env.REACT_APP_BASE_URL}ServiceRequest/DownloadCalenderEventFile?ticket_id_ids=${localStorage.getItem("ticketIdDownlaod")}`;

        axios.get(url, {
            headers: {
                'timezone': timeZone
            },
            responseType: 'blob' // Important for handling the binary data correctly
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Chilll_service_${localStorage.getItem("ticketIdDownlaod")}_calender_event.ics`); // Adjust the file name as needed
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                console.error('Error occured: ', error);
            });
    };

    function handleFeedbackModal(type, message) {
        setFeedbackMessage(message)
        setFeedbackModal(false);
        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 11000);
    }

    return (
        <>


            <div
                style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                className="position-relative"
            >
                <div
                    className="position-absolute"
                    style={{ top: "20px", right: "20px" }}
                >
                    <span
                        className="text-decoration-underline cursor-pointer text-black"
                        onClick={() => {
                            setFeedbackModal(true);
                        }}
                    >
                        {"Give us feedback"}
                    </span>
                </div>

                <div className="deepLink-sub-container" style={{ width: '95%', height: '65%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center', padding: '10px', background: 'white', borderRadius: '20px' }}>
                    <div>
                        <div className="d-flex justify-content-center align-items-center" style={{ marginBottom: '15px' }}>
                            <img src={logo} alt="chill app logo" className="logo_login" style={{ marginTop: '60px', width: '150px' }} />
                        </div>

                        <p className="text-center" style={{ margin: '5px', fontSize: '15px' }}> Download schedule by clicking on download button </p>
                    </div>

                    <div>
                        <PrimaryButton
                            buttonName={"DOWNLOAD"}
                            onClick={downloadFile}
                            style={{
                                width: '100%',
                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                border: '2px solid rgba(255, 154, 32, 1)',
                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                fontWeight: '600',
                            }}
                        />

                        <div className="w-100 my-3 d-flex justify-content-center">
                            <span className="text-center" style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => { navigate("/login") }}>{authorized ? "Go to dashboard" : "Login"}</span>
                        </div>
                        {/* <PrimaryButton  buttonName={"Login"} onClick={() => { navigate("/login") }} /> */}
                    </div>
                </div>
            </div>

            {feedbackModal && (
                <FeedbackModal
                    addUserTrigger={feedbackModal}
                    handleCloseAddUser={handleFeedbackModal}
                />
            )}

            {handleToaster && (
                <ResponceToaster toasterType={"success"} message={feedbackMessage} />
            )}
        </>
    );
}

export default ScheduleCallDownload;